import cx from 'classnames'
import { observer } from 'mobx-react-lite'

import { ReactComponent as FilterIcon } from 'assets/icons/filter16.svg'
import { Button } from 'components/Button'

import { CollaborationDialogAddButton } from './CollaborationDialogAddButton'
import { CollaborationDialogChevron } from './CollaborationDialogChevron'
import { CollaborationDialogCloseButton } from './CollaborationDialogCloseButton'
import { CollaborationDialogHead } from './CollaborationDialogHead'
import { useCollaborationDialog } from './CollaborationDialogStore'

import Styles from './CollaborationDialogAllCommentsHead.module.scss'

export const CollaborationDialogAllCommentsHead = observer(function CollaborationDialogAllCommentsHead() {
  return (
    <CollaborationDialogHead>
      <div className={Styles.left}>
        <div className={Styles.commentsLabel}>Comments</div>
        <CollaborationDialogAddButton />
      </div>
      <div className={Styles.right}>
        <FilterButton />
        <CollaborationDialogChevron />
        <CollaborationDialogCloseButton />
      </div>
    </CollaborationDialogHead>
  )
})

const FilterButton = observer(() => {
  const collaborationDialogStore = useCollaborationDialog()
  const onFilterToggle = () => collaborationDialogStore.toggleFilters()

  return (
    <Button
      className={cx({
        [Styles.buttonSelected]: collaborationDialogStore.showFilters,
      })}
      frontIcon={FilterIcon}
      variant="none"
      size="lg"
      preventFocusOnPress
      onClick={onFilterToggle}
    />
  )
})
